export type EntryAvailabilityState = 'deleted' | 'unavailable' | null;

type EntryRecord = {
	Id?: string;
	Entry?: { Status?: unknown };
};

export const getEntryAvailabilityState = (entryRecordInput: unknown, requestedEntryId?: string): EntryAvailabilityState => {
	const entry = entryRecordInput as EntryRecord | null | undefined;

	if (!entry?.Entry)
		return 'unavailable';

	if (requestedEntryId && entry.Id !== requestedEntryId)
		return 'unavailable';

	const currentStatus = typeof entry.Entry.Status === 'string' ? entry.Entry.Status.trim().toLowerCase() : '';

	if (currentStatus === 'deleted')
		return 'deleted';

	return null;
};
